import { Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedName from 'I18n/components/FormattedName';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error untyped import
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewReplyThread({
  reply: replyMap,
  onReportReplyClick,
  TagComponent
}) {
  const {
    reply,
    repliedAt,
    replierDisplayName,
    avatarUrl,
    companyName
  } = replyMap;
  if (!reply) {
    return null;
  }
  const displayName = replierDisplayName || I18n.text('marketplace-ui-reviews.defaultReplierName');
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {}), TagComponent && /*#__PURE__*/_jsx(TagComponent, {}), /*#__PURE__*/_jsxs(TFlex, {
      "data-test-id": "review-reply-thread",
      direction: "column",
      paddingInlineStart: "1100",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(UIAvatar, {
          size: "xs",
          src: avatarUrl
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          marginInline: "300",
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: companyName ? 'marketplace-ui-reviews.replyThread.title_jsx' : 'marketplace-ui-reviews.replyThread.titleWithoutCompany_jsx',
            options: {
              displayName,
              companyName
            },
            elements: {
              Name: FormattedName,
              Bold: 'b'
            }
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: repliedAt,
            format: "ll",
            type: "userTz"
          })
        })]
      }), /*#__PURE__*/_jsx(TFlex, {
        children: /*#__PURE__*/_jsx("span", {
          "data-test-id": "review-reply-text",
          children: reply
        })
      }), onReportReplyClick && /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: onReportReplyClick,
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.replyThread.report"
        })
      })]
    })]
  });
}